import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

type State = {
    novosNegociosArquivos: PaginationProperties,
}

type Action = {
    novosNegociosArquivosSetter: SetPaginationProperties,
}

export const useNovosNegociosCadastroPagination = create<State & Action>((set) => ({
    novosNegociosArquivos: InitializePaginationProperties({ rowsPerPage: 5 }),
    novosNegociosArquivosSetter: InitializeSetPaginationProperties(set, 'novosNegociosArquivos'),

}));